<template>
  <div>
    <span class="cw-sr-only">Loading Location Latency</span>
    <div class="cw-animate-pulse cw-grid cw-grid-cols-2 cw-gap-2 cw-pt-11">
      <div class="cw-flex cw-flex-col cw-gap-1">
        <div :class="`cw-w-28 cw-h-4 cw-rounded cw-bg-slate-300`" />
        <div :class="`cw-w-full cw-h-8 cw-rounded cw-bg-slate-300`" />
      </div>
      <div class="cw-flex cw-flex-col cw-gap-1">
        <div :class="`cw-w-28 cw-h-4 cw-rounded cw-bg-slate-300`" />
        <div :class="`cw-w-full cw-h-8 cw-rounded cw-bg-slate-300`" />
      </div>
      <div :class="`cw-w-full cw-h-8 cw-rounded cw-bg-slate-300`" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LocationLatencyFiltersSkeleton',
}
</script>
